var map = {
	"./en.json": [
		1191,
		105
	],
	"./es.json": [
		1192,
		106
	],
	"./pt.json": [
		1193,
		107
	],
	"./widgets/en.json": [
		877,
		9
	],
	"./widgets/es.json": [
		878,
		10
	],
	"./widgets/pt.json": [
		879,
		11
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 771;
module.exports = webpackAsyncContext;